module.exports = __webpack_public_path__ + "static/media/400388_02.4cb1d643.png";